export class AwsOpenSearchDomainRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsOpenSearchDomain",
            "baseName": "awsOpenSearchDomain",
            "type": "AwsOpenSearchDomainRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsOpenSearchDomainRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
